import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'app/_services/loader.service';
import { environment } from 'environments/environment';
import { HttpClient } from "@angular/common/http";


import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
import * as _ from "lodash";
import { AuthService } from 'app/_services';
import { Observable, Subscription } from 'rxjs';

import { process, State } from '@progress/kendo-data-query';
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';

const distinctAssZone = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.zone === x.zone) === idx);
const distinctCurrZone = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.RUNNINGZONE === x.RUNNINGZONE) === idx);
const distinctAssWard = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.ward === x.ward) === idx);
const distinctCurrWard = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.RUNNINGWARD === x.RUNNINGWARD) === idx);
const distinctParking = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.parkLocName === x.parkLocName) === idx);
const distinctStatus = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.CURRENT_STATUS === x.CURRENT_STATUS) === idx);
const distinctVehType = (data) => data.filter((x, idx, xs) => xs.findIndex((y) => y.vehtypname === x.vehtypname) === idx);

const moment = _rollupMoment || _moment;
export const MY_FORMATS = {
    parse: {
        dateInput: 'LL'
    },
    display: {
        dateInput: 'LL',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY'
    }
};
declare var $: any;
declare var google: any;
declare var firebase: any;
declare var MapLabel: any;
var stopAnimation = true;

declare const MarkerClusterer;

@Component({
  selector: 'app-veh-dashboard',
  templateUrl: './veh-dashboard.component.html',
  styleUrls: ['./veh-dashboard.component.scss']
})
export class VehDashboardComponent implements OnInit {
  public distinctAssZone: any[];
  public distinctCurrZone: any[];
  public distinctAssWard: any[];
  public distinctCurrWard: any[];
  public distinctParking: any[];
  public distinctStatus: any[];
  public distinctVehType: any[];
  map: any
  countData: any;
  showLoader: any;
  prjID: string;
  public date = moment();
  authtoken: any;
  allVehiclesData: any;
  private subscription: Subscription;
  zones = [];
  zonesList: { name: string; count: number; }[];
  selctedZone: any;
  zoneName: any;
  zoneVehCount: any;
  vehiclesData = [];
  vehiclesData2 = [];
  routePath: any[];
  route: any;
  multiRoute: any;
  polygondData: any;
  isNotWorking: boolean = false;
  markerCluster: any;
  allMarkers = [];
  vehicleCluster: any;
  isClickedVehicle: any;

  public groups: GroupDescriptor[] = [];
  public view: Observable<GridDataResult>;
  public gridView: DataResult;
  markerStart: any;
  markerEnd: any;
  totalStop: number;
  totalDuration: string;
  currIMEI: any;
  totalStopsCount: any;
  totalStopsData: any;
  delayedStop: any;
  greenStop: any;
  isSuperAdmin: boolean;
  vehiclesLocation: any;
  routePolygondData: any;

  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.vehiclesData
    };
    return result;
  }

  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups;
    this.loadProducts();
  }

  public state: State = {
    skip: 0,
    take: 50,
    filter: {
      logic: 'and',
      filters: []
    }
  };

  private loadProducts(): void {
    this.gridinventory = process(this.vehiclesData, { group: this.groups });
  }
  public gridinventory: GridDataResult;

  constructor(
    private loaderService: LoaderService,
    private auth: AuthService,
    private http: HttpClient
  ) { 
    this.authtoken = JSON.parse(localStorage.getItem('authData'));
    this.prjID = this.auth.getAuthentication().projectId;
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    });

    this.countData = {
      TOTAL: 0,
      RUNNING: 0,
      NOT_STARTED: 0,
      STOPPED: 0,
      WORKING: 0,
      NOTWORKING: 0,
      OFFLINE: 0,
      TOTALRUNNING: 0,
      DATA_NOT_RECEIVED: 0,
      VTSINSTALLED: 0,
      VTSNOTINSTALLED: 0,
      MAINTENANCE: 0,
      STANDBY: 0,
    };

    this.zonesList = [
      {name: 'ZONE-1', count : 90},
      {name: 'ZONE-2', count : 65},
      {name: 'ZONE-3', count : 49},
      {name: 'ZONE-4', count : 71}
    ]
  }

  getDataWhenProjectChange = async (id) => {
    $('#loderImgTab').show();
    this.loaderService.display(true);

    let polygon = await fetch(
      environment.apiUrl + 'entity/getPolygonByOemId' + '?prjid=' + id + '&wardOemId=null' + '&beatOemId=null',
      {
          method: 'get',
          headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
              Authorization: this.authtoken.token
          }
      }
    );
    this.polygondData = await polygon.json();

    let d = await fetch(
        environment.apiUrl +
        'vehicles/getAll?prjId=' +
        this.prjID +
        '&date=' +
        moment(this.date).format('YYYY-MM-DD'),
        {
            method: 'get',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: this.authtoken.token
            }
        }
    );
    this.allVehiclesData = await d.json();
    this.applyFilter(this.allVehiclesData.liveData)
    this.getCount(this.allVehiclesData.liveData);
    this.plotAllVehicles(this.vehiclesData);
    this.loaderService.display(false);
    this.getRunningStatusData('TOTAL')

    $('.background').hide();
    $('#loderImgTab').hide();
    $('#progress-bar').hide();
  };

  getCount(sqlDb) {

 
    var TOTAL = 0;
    var WORKING = 0;
    var OFFLINE = 0;
    var DATA_NOT_RECEIVED = 0;
    var VTSINSTALLED = 0;
    var VTSNOTINSTALLED = 0;
    var RUNNING = 0;
    var NOT_STARTED = 0;
    var STOPPED = 0;
    var STANDBY = 0;
    var MAINTENANCE = 0;
    for (var i = 0; i < sqlDb.length; i++) {
      if(sqlDb[i].FUELTYPE == 'Diesel' && sqlDb[i].vehcatname == 'Primary'){
        TOTAL++
          if (sqlDb[i].IMEI == null) {
              sqlDb[i].VTSINSTALLED = 'NO';
          } else {
              sqlDb[i].VTSINSTALLED = 'YES';
          }
          if (sqlDb[i].VTSINSTALLED == 'YES') {
              if (sqlDb[i].VTSSTATUS != 'OFFLINE' && sqlDb[i].VTSSTATUS != 'LIVE')
                  sqlDb[i].VTSSTATUS = 'DATA_NOT_RECEIVED';
          }
  
          if (sqlDb[i].VTSSTATUS == 'LIVE' && sqlDb[i].MAINTID != 3 && sqlDb[i].MIANTSTATUS != 'STANDBY') {
            WORKING++;
              if (sqlDb[i].DISTANCE > 1 && sqlDb[i].duration <= 20) {
                  RUNNING++;
                  sqlDb[i].RUNNING_STATUS = 'RUNNING';
                  sqlDb[i].CURRENT_STATUS = 'RUNNING';
              } else if (sqlDb[i].DISTANCE > 1 && sqlDb[i].duration > 20) {
                  STOPPED++;
                  sqlDb[i].RUNNING_STATUS = 'STOPPED';
                  sqlDb[i].CURRENT_STATUS = 'STOPPED';
              } else if (sqlDb[i].DISTANCE < 1 || sqlDb[i].duration == 'NULL' || sqlDb[i].DISTANCE == 'NULL') {
                  NOT_STARTED++;
                  sqlDb[i].RUNNING_STATUS = 'NOT_STARTED';
                  sqlDb[i].CURRENT_STATUS = 'NOT_STARTED';
              }
  
          }
          if (sqlDb[i].VTSSTATUS == 'OFFLINE') {
              OFFLINE++;
              sqlDb[i].CURRENT_STATUS = 'OFFLINE';
          }
  
          if (sqlDb[i].VTSSTATUS == 'DATA_NOT_RECEIVED' && sqlDb[i].MAINTID != 3 && sqlDb[i].MIANTSTATUS != 'STANDBY') {
              DATA_NOT_RECEIVED++;
              sqlDb[i].CURRENT_STATUS = 'DATA_NOT_RECEIVED';
          }
          if (sqlDb[i].VTSINSTALLED == 'YES') {
              VTSINSTALLED++;
          }
  
          if (sqlDb[i].VTSINSTALLED == 'NO') {
              VTSNOTINSTALLED++;
          }
  
          if (sqlDb[i].MIANTSTATUS == 'STANDBY') {
              STANDBY++;
              sqlDb[i].CURRENT_STATUS = 'STANDBY';
          }
  
          if (sqlDb[i].MAINTID == 3) {
              MAINTENANCE++;
              sqlDb[i].CURRENT_STATUS = 'MAINTENANCE';
          }
      }
    }

    this.countData = {
        TOTAL: TOTAL,
        VTSINSTALLED: VTSINSTALLED,
        VTSNOTINSTALLED: VTSNOTINSTALLED,
        WORKING: RUNNING + STOPPED + NOT_STARTED,
        RUNNING: RUNNING,
        STOPPED: STOPPED + NOT_STARTED,
        OFFLINE: OFFLINE, 
        DATA_NOT_RECEIVED: DATA_NOT_RECEIVED,
        STANDBY: STANDBY,
        MAINTENANCE: MAINTENANCE,
        NOTWORKING: OFFLINE + DATA_NOT_RECEIVED + STANDBY + MAINTENANCE,
    };
  }

  viewRouteOnMap(data){
    console.log(data);
    
    this.loaderService.display(true);
    this.getMapRoute(data);
    this.getStopInfo(data.IMEI)
    $('#viewRoute').modal('show');
    this.getAssignroute(data);
    this.loaderService.display(false);
  }

  getAssignroute(id) {

     
    this.removeAssignRoute();
    this.http.get(environment.apiUrl + 'entity/getVehicleroute?' + 'vehId=' + id.id).subscribe((data) => {
        console.log(data);
        var result: any;
        result = data;
        this.map.data.addGeoJson(result.geoJson);
    });
}

removeAssignRoute() {
  this.map.data.forEach((feature) => {
      if (feature.getProperty('Oemid') == 10) {
          this.map.data.remove(feature);
      }
  });
}

  getMapRoute(data) {
    this.clearFeature()
    var date = moment(this.date).format('YYYY-MM-DD')
    this.http.get(environment.apiUrl + 'vehicles/route' + '?DEVICEID=' + data.IMEI + '&prjId=' + this.prjID + '&date=' + date + '&accuracy=false').subscribe(data => {
      var result: any
      result = data
      this.removeLine();
      this.createRoute(this.map, result.latLong, result.STARTPOINT, result.ENDPOINT);
    this.plotStartAndEndPoint(result.STARTPOINT, result.ENDPOINT);
    })
  }

  createRoute(map, pathCoords, startPoint, endPoint) {
    var i;
    var polyCords = [];
    var data = this.allVehiclesData.liveData
    if (this.markerCluster) {
        this.markerCluster.clearMarkers();
    }

    this.renoveAllMarker();
    for (i = 0; i < pathCoords.length; i++) {
        polyCords.push({ lat: JSON.parse(pathCoords[i][1]), lng: JSON.parse(pathCoords[i][0]) });
    }
    var car =
        'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z';
    var icon = {
        path: car,
        scale: 1,
        strokeColor: 'white',
        strokeWeight: 0.1,
        fillOpacity: 5,
        fillColor: '#35370C',
        offset: '2%',
        // rotation: parseInt(heading[i]),
        anchor: new google.maps.Point(10, 25) // orig 10,50 back of car, 10,0 front of car, 10,25 center of car
    };
    this.routePath = polyCords;
    this.map.data.addGeoJson(this.polygondData.geoJson);
    this.route = new google.maps.Polyline({
        path: polyCords,
        strokeColor: '#9110c4',
        strokeOpacity: 4.0,
        strokeWeight: 5,
        icons: [
            {
                icon: icon,
                offset: '100%'
            }
        ],
        map: map
    });
    this.zoomToObject(this.route);
  }

  plotStartAndEndPoint(startPoint, endPoint) {
    var start = new google.maps.LatLng(startPoint.LAT, startPoint.LONG);
    var end = new google.maps.LatLng(endPoint.LAT, endPoint.LONG);
    this.markerStart = new google.maps.Marker({
        position: start,
        map: this.map,
        icon: 'assets/img/start.png',

        labelClass: 'labels', // the CSS class for the label
        labelStyle: { opacity: 1.0 }
    });
    this.markerEnd = new google.maps.Marker({
        position: end,
        map: this.map,
        icon: 'assets/img/end.png'
    });
  }

  getStopInfo = async (data) => {
    var date = moment(this.date).format('YYYY-MM-DD')
    let stopInfo = await fetch(
        environment.apiUrl + 'getStopInfo?DEVICEID=' + data + '&DEVICEDATE=' + date,
        {
            method: 'get',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: this.authtoken.token
            }
        }
    );
    let stop_info_data = await stopInfo.json();
    this.plotStopPosition(stop_info_data);
    this.totalStopsCount = stop_info_data.length
    this.totalStopsData = stop_info_data
  };

  plotStopPosition(stopInfo) {    
    this.clearStopMarker();
    var data = { features: [], type: '' };
    data.type = 'FeatureCollection';
    var coordinates = [];
    var stop = 0;
    var totalDuration = 0;
    for (var i = 0; i < stopInfo.length; i++) {
        if (stopInfo[i].LONG && stopInfo[i].LAT) {
            stop++;
            var geometry = { coordinates: [], type: '' };
            geometry.coordinates.push(Number(stopInfo[i].LONG), Number(stopInfo[i].LAT));
            geometry.type = 'Point';
            var duration = this.diff_hours(new Date(stopInfo[i].STARTTIME), new Date(stopInfo[i].ENDTIME));
            var difInMinutes = this.diff_minutes(new Date(stopInfo[i].STARTTIME), new Date(stopInfo[i].ENDTIME));
            // console.log('difInMinutes', difInMinutes);
            totalDuration = totalDuration + stopInfo[i].duration;
            data.features.push({
                geometry: geometry,
                type: 'Feature',
                properties: {
                    DEVICEID: stopInfo[i].DEVICEID,
                    VEHICLE_NO: stopInfo[i].VEHICLE_NO,
                    STARTTIME: stopInfo[i].STARTTIME,
                    ENDTIME: stopInfo[i].ENDTIME,
                    DURATION: duration,
                    difInMinutes: difInMinutes,
                    ZONE: stopInfo[i].zoneName,
                    WARD: stopInfo[i].WardName,
                    BEAT: stopInfo[i].beatName,
                    TYPE: 'stopMarker',
                    engineStatus: stopInfo[i].ACC == 0 ? 'Off' : 'On',
                    number: stop
                }
            });
        }
    }
    this.totalStop = stop;
    var hours = totalDuration / 60;
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    this.totalDuration = rhours + ': ' + rminutes + '(hh:mm)';
    this.map.data.addGeoJson(data);
    this.setStyle()
  }

  setStyle() {
    var delayedStop
    var greenStop
    this.map.data.setStyle(function (feature) {
      var color = feature.getProperty('FillColor');
      var strokeColor = feature.getProperty('Bcolor');
      if (feature.getProperty('TYPE') == 'stopMarker') {
        if (feature.getProperty('difInMinutes') > 20) {
          var icon = 'assets/img/delayStop.png';
          delayedStop++
        } else {
          var icon = 'assets/img/stopMarker.png';
          greenStop++
        }
        return {
          fillColor: color,
          strokeColor: strokeColor,
          strokeWeight: 2,
          fillOpacity: 0.05,
          icon: icon,
          strokeopacity: 0.2,
          label: {
            text: feature.getProperty('number'),
            color: '#FFFFFF',
            fontSize: '13px',
            background: 'yellow',
            fontWeight: 'bold',
            AlignmentVertical: 'top',
            AlignmentHorizontal: 'center'
          },
          labelClass: 'my-custom-class-for-label'
        };
      }
    });
    this.delayedStop = delayedStop
    this.greenStop = greenStop
  }

  renoveAllMarker() {
    if (this.allMarkers.length > 0) {
        for (var i = 0; i < this.allMarkers.length; i++) {
            this.allMarkers[i].setVisible(false);
        }
    }
  }

  removeMarker() {
    if (this.markerStart && this.markerEnd) {
        this.markerStart.setMap(null);
        this.markerEnd.setMap(null);
    } else if (this.markerStart) {
        this.markerStart.setMap(null);
    }
  }

  clearStopMarker() {
    this.map.data.forEach((feature) => {
        if (feature.getProperty('TYPE') == 'stopMarker' || feature.getProperty('TYPE') == 'engine_Off') {
            this.map.data.remove(feature);
        }
    });
  }

  diff_hours(dt2, dt1) {
    var difference = dt1.getTime() - dt2.getTime(); // This will give difference in milliseconds
    var resultInMinutes = Math.round(difference / 60000);
    var hours = resultInMinutes / 60;
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    return rhours + ': ' + rminutes;
  }

  diff_minutes(dt2, dt1) {
      var difference = dt1.getTime() - dt2.getTime(); // This will give difference in milliseconds
      var resultInMinutes = Math.round(difference / 60000);
      var hours = resultInMinutes / 60;
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      return rminutes;
  }

  zoomToObject(obj) {
    var bounds = new google.maps.LatLngBounds();
    var points = obj.getPath().getArray();
    for (var n = 0; n < points.length; n++) {
        bounds.extend(points[n]);
    }
    this.map.fitBounds(bounds);
  }

  removeLine() {
    if (this.route) {
        this.route.setMap(null);
    }
  }

  clearFeature() {
    this.map.data.forEach((feature) => {
      this.map.data.remove(feature);
    })
  }

  selectZone(data) {
    // this.selctedZone = data.PRJNAME;
    console.log(data);
    for(var i = 0; i<this.zonesList.length; i++){
      if(data.name == this.zonesList[i].name){
        this.zoneName = this.zonesList[i].name
        this.zoneVehCount = this.zonesList[i].count
      }
    }
    
  }

  getRunningStatusData(status) {
    this.loaderService.display(true);
    $('#loderImgTab').show();
    this.isNotWorking = false
    this.applyFilter(this.allVehiclesData.liveData);
    var data = this.vehiclesData;
    this.vehiclesData = [];
    for (var i = 0; i < data.length; i++) {
      if (status == 'notWorking') {        
        if (data[i].VTSSTATUS == 'OFFLINE' || data[i].VTSSTATUS == 'DATA_NOT_RECEIVED' || data[i].MAINTID == 3 || data[i].MIANTSTATUS == 'STANDBY') {
          this.vehiclesData.push(data[i]);
        }
        this.isNotWorking = true
      }
      else if(status == 'STOPPED'){
        if (data[i].RUNNING_STATUS == 'STOPPED' || data[i].RUNNING_STATUS == 'NOT_STARTED') {
          this.vehiclesData.push(data[i]);
        }
      }
      else if(status == 'TOTAL'){
        this.vehiclesData.push(data[i]);
      }
      else if(status == 'WORKING'){
        if (data[i].RUNNING_STATUS == 'RUNNING' || data[i].RUNNING_STATUS == 'STOPPED' || data[i].RUNNING_STATUS == 'NOT_STARTED') {
          this.vehiclesData.push(data[i]);
        }
      }
      else {
        if (data[i].RUNNING_STATUS == status) {
          this.vehiclesData.push(data[i]);
        }
      }
    } 
    this.gridinventory = process(this.vehiclesData, this.state);
    this.allData = this.allData.bind(this);
    this.distinctAssZone = distinctAssZone(this.vehiclesData);
    this.distinctCurrZone = distinctCurrZone(this.vehiclesData);
    this.distinctAssWard = distinctAssWard(this.vehiclesData);
    this.distinctCurrWard = distinctCurrWard(this.vehiclesData);
    this.distinctParking = distinctParking(this.vehiclesData);
    this.distinctStatus = distinctStatus(this.vehiclesData);
    this.distinctVehType = distinctVehType(this.vehiclesData);
    this.loaderService.display(false);
    $('#loderImgTab').hide();
    this.plotAllVehicles(this.vehiclesData);
  }

  applyFilter(data) {
    var result = [];
    for (var i = 0; i < data.length; i++) {
      if (data[i].vehcatname == 'Primary' && data[i].FUELTYPE == 'Diesel') {
          result.push(data[i]);
      }
    }

    this.vehiclesData = result;
  }
 
  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridinventory = process(this.vehiclesData, this.state);
    if (state && state.group) {
      this.gridinventory = process(this.vehiclesData, this.state);
    }
  }

  dateChanged() {
    this.getDataWhenProjectChange(this.prjID);
  }

  viewLocation(){
    $('.tables').toggleClass('slide-left-summary')
    $('.map-view').toggleClass('map-view-wide')
    $('kendo-grid').toggleClass('kendo-display')
    $('.map-view-box').toggleClass('map-view-box-toggle')
    $('.veh-list').toggleClass('veh-list-wide')
    $('.vts_installed_border').toggleClass('vts_installed_border_wide')
    $('.fa-angle-left').toggleClass('fa-angle-right');
  }
  
  plotAllVehicles(data) {
    var locations = [];
    var thisRef = this;
    var infoWindow = new google.maps.InfoWindow();
    var bounds = new google.maps.LatLngBounds();
    var icon;
    var labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    if (this.markerCluster) {
      this.markerCluster.clearMarkers();
    }

    this.renoveAllMarker();
    var markers = [];
    var car =
      'M17.402,0H5.643C2.526,0,0,3.467,0,6.584v34.804c0,3.116,2.526,5.644,5.643,5.644h11.759c3.116,0,5.644-2.527,5.644-5.644 V6.584C23.044,3.467,20.518,0,17.402,0z M22.057,14.188v11.665l-2.729,0.351v-4.806L22.057,14.188z M20.625,10.773 c-1.016,3.9-2.219,8.51-2.219,8.51H4.638l-2.222-8.51C2.417,10.773,11.3,7.755,20.625,10.773z M3.748,21.713v4.492l-2.73-0.349 V14.502L3.748,21.713z M1.018,37.938V27.579l2.73,0.343v8.196L1.018,37.938z M2.575,40.882l2.218-3.336h13.771l2.219,3.336H2.575z M19.328,35.805v-7.872l2.729-0.355v10.048L19.328,35.805z';

    for (var i = 0; i < data.length; i++) {
      if (data[i].LAT && data[i].LONG) {
        if (data[i].RUNNING_STATUS == 'RUNNING') {
          var color = '#4AA951';
        } else if (data[i].RUNNING_STATUS == 'STOPPED') {
          var color = '#DF8F1C';
        } else if (data[i].RUNNING_STATUS == 'NOT_STARTED') {
          var color = '#A9525E';
        }

        var item = data[i];
        if (!item.ANGLE) {
          var rotation = 0;
        } else {
          rotation = item.ANGLE;
        }

        icon = {
          path: car,
          scale: 0.7,
          strokeColor: 'black',
          strokeWeight: 1,
          fillOpacity: 1,
          fillColor: color,
          offset: '1%',
          rotation: rotation //<-- Car angle
        };

        if (item.LAT && item.LONG) {
          if (item.RUNNINGWARD != item.ward) {
            var marker = new google.maps.Marker({
              position: { lat: JSON.parse(item.LAT), lng: JSON.parse(item.LONG) },
              icon: icon,
              label: {
                text: 'X',
                icon: car,
                color: '#D03207',
                fontSize: '16px',
                labelAnchor: new google.maps.Point(25, 65),
                background: 'yellow',
                fontWeight: 'bold'
              }
            });
          } else {
            var marker = new google.maps.Marker({
              position: { lat: JSON.parse(item.LAT), lng: JSON.parse(item.LONG) },
              icon: icon
            });
          }

          marker.id = item.IMEI;
          marker.vehno = item.vehno;
          marker.SPEED = item.SPEED;
          marker.dateTime = item.HEARTBEATDATE;
          marker.type = item.vehtypname;
          marker.WARD = item.RUNNINGWARD;
          marker.ZONE = item.RUNNINGZONE;

          marker.assignWard = item.ward;

          marker.MIANTSTATUS = item.MIANTSTATUS;

          markers.push(marker);
          this.allMarkers.push(marker);
          if (!this.vehicleCluster) {
            marker.setMap(this.map);
          }
        }
        (function (marker, data) {
          google.maps.event.addListener(marker, 'click', function (e) {
            thisRef.isClickedVehicle = data.IMEI;

            //Wrap the content inside an HTML DIV in order to set height and width of InfoWindow.
            var content =
              "<div class='col-sm-12 '>" +
              "</p><p class='info-deatil'><strong>Vehicle No:</strong>" +
              '  ' +
              marker.vehno +
              ' ( ' +
              marker.type +
              ' ) ' +
              "</p><p class='info-deatil'><strong>Assign Ward:</strong>" +
              '  ' +
              marker.assignWard +
              "</p><p class='info-deatil'><strong>Running Ward:</strong>" +
              '  ' +
              marker.WARD +
              "</p><p class='info-deatil'><strong>Status</strong>" +
              '  ' +
              marker.MIANTSTATUS +
              "</p><p class='info-deatil'><strong>Speed:</strong>" +
              '  ' +
              marker.SPEED +
              ' ' +
              'Km/h' +
              "</p><p class='info-deatil'><strong>Last Updated: </strong>" +
              '  ' +
              marker.dateTime +
              ' ' +
              // "</p><p class='info-deatil'><strong>Area :</strong>" + "  " + marker.BEAT + "</p> " +
              '</div>';
            infoWindow.setContent(content);
            infoWindow.open(this.map, marker);
          });
        })(marker, item);
      }
    }
    if (this.vehicleCluster) {
      this.markerCluster = new MarkerClusterer(this.map, markers, {
        imagePath: 'HttpClient s://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m'
      });
    }
  }  
  // viewSummary(){
  //   $('.map-view').toggleClass('slide-left-summary')
  //   $('summary-Btn').css('display','none')
  //   $('kendo-grid').css('display','block')
  // }

  reload() {
    $('#loderImgTab').hide();
    $('#infotable1').hide();
    $('#infotable2').hide();
    $('#statusTable').show();
    $('#play').show();
    $('#stop').hide();
    $('#veichiclesInfo-bar').hide();
    $('#progress-bar').hide();
    this.getDataWhenProjectChange(this.prjID);
  }

  async refreshCount(id) {
    let d = await fetch(
        environment.apiUrl +
        'vehicles/getAll?prjId=' +
        this.prjID +
        '&date=' +
        moment(this.date).format('YYYY-MM-DD'),
        {
            method: 'get',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: this.authtoken.token
            }
        }
    );
    this.allVehiclesData = await d.json();
    this.getCount(this.allVehiclesData.liveData);
  }

  async refreshLiveData() {
    let vehicles = await fetch(environment.apiUrl + 'vehicles/location/all' + '?prjID=' + this.prjID, {
        method: 'get',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: this.authtoken.token
        }
    });
    this.vehiclesLocation = await vehicles.json();
    this.plotAllVehicles(this.vehiclesLocation);
  }

  ngOnInit() {
    this.getDataWhenProjectChange(this.prjID);
    var authData = JSON.parse(localStorage.getItem('authData'))

    if(authData.id == 19 || authData.id == 445){
      this.isSuperAdmin = true
    }
    else {
      this.isSuperAdmin = false
    }

    this.subscription = Observable.interval(10 * 1000).subscribe((x) => {
      this.refreshCount(this.prjID)
    });

    var myOptions = {
      center: new google.maps.LatLng(28.47769599987369, 77.06160699973178),
      zoom: 13,
      panControl: true,
      mapTypeControl: true,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
        position: google.maps.ControlPosition.TOP_LEFT
      },
      zoomControlOptions: {
        position: google.maps.ControlPosition.LEFT_BOTTOM,
        style: google.maps.ZoomControlStyle.SMALL
      },
      // fullscreenControlOptions: {
      //   position: google.maps.ControlPosition.TOP_CENTER,
      //   style: google.maps.ControlPosition.SMALL
      // }

    };
    this.map = new google.maps.Map(document.getElementById('map'), myOptions);
  }

  ngOnDestroy(){
    if (this.subscription){
        this.subscription.unsubscribe();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/maptracker/veh-dashboard/veh-dashboard.component.ts